var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerspectivegridflat1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2523,
    height: 412,
    viewBox: "0 0 2523 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1059.26 10.8458H1463.74M1053.49 13.0911H1469.52M1047.37 15.47H1475.63M1040.89 17.9919H1482.11M1034 20.671H1489M1026.67 23.5233H1496.33M1018.85 26.5661H1504.15M1010.49 29.8181H1512.51M1001.54 33.3021H1521.46M991.919 37.0437H1531.08M981.562 41.0732H1541.44M970.378 45.4238H1552.62M958.263 50.137H1564.74M945.095 55.2603H1577.9M930.733 60.8476H1592.27M915.004 66.9672H1608M897.705 73.6966H1625.3M878.588 81.1344H1644.41M857.35 89.397H1665.65M833.618 98.6293H1689.38M806.924 109.015H1716.08M776.679 120.782H1746.32M742.122 134.225H1780.88M702.261 149.733H1820.74M655.773 167.819H1867.23M600.855 189.185H1922.14M534.986 214.811H1988.01M454.527 246.113H2068.47M354.028 285.212H2168.97M224.937 335.434H2298.06M2392.01 402.315L1445.58 8.7207M2314.04 402.315L1432.89 8.7207M2236.08 402.315L1420.19 8.7207M2158.11 402.315L1407.5 8.7207M2080.14 402.315L1394.8 8.7207M2002.18 402.315L1382.11 8.7207M1924.21 402.315L1369.41 8.7207M1846.25 402.315L1356.72 8.7207M1768.28 402.315L1344.02 8.7207M1690.31 402.315L1331.33 8.7207M1612.35 402.315L1318.63 8.7207M1534.38 402.315L1305.93 8.7207M1456.42 402.315L1293.24 8.7207M1378.45 402.315L1280.54 8.7207M1300.48 402.315L1267.85 8.7207M1222.52 402.315L1255.15 8.7207M1144.55 402.315L1242.46 8.7207M1066.59 402.315L1229.76 8.7207M988.619 402.315L1217.07 8.7207M910.653 402.315L1204.37 8.7207M832.687 402.315L1191.68 8.7207M754.72 402.315L1178.98 8.7207M676.755 402.315L1166.28 8.7207M598.788 402.315L1153.59 8.7207M520.822 402.315L1140.89 8.7207M442.856 402.315L1128.2 8.7207M364.89 402.315L1115.5 8.7207M286.924 402.315L1102.81 8.7207M208.958 402.315L1090.11 8.7207M130.991 402.315L1077.42 8.7207M53.0257 402.315H2469.97L1458.28 8.7207H1064.72L53.0257 402.315Z",
    stroke: "url(#paint0_linear_2514_43089)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2514_43089",
    x1: 1261.5,
    y1: 8.7207,
    x2: 1261.5,
    y2: 402.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#E8E8DB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557292,
    stopColor: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8DB",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerspectivegridflat1);
export default __webpack_public_path__ + "static/media/perspectivegridflat-1.e637da8d85362f168db4c3488c087cfa.svg";
export { ForwardRef as ReactComponent };